import React, {Component} from 'react';
import Toast from "../Common/Toast";
import NavBar from "../Common/NavBar";
import TopMenu from "../Common/TopMenu";
import {
    faPlusSquare,
    faEdit,
    faLevelUpAlt,
    faLevelDownAlt,
    faWindowClose,
    faEyeSlash
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import API from "../../services/API";
import {toast} from "react-toastify";

class Addresses extends Component {
    state = {
        addresses: []
    }
    onDeleteClick = (id) => {

        API.deleteAddresses(id)
            .then((response) => {
                toast.success(response.user_message);
                API.getAddresses()
                    .then((response) => {
                        const addresses = response.results.addresses;
                        this.setState({addresses})

                    })
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    onDefaultClick = (id,type) => {

        API.defaultAddresses(id,type)
            .then((response) => {
                toast.success(response.user_message);
                API.getAddresses()
                    .then((response) => {
                        const addresses = response.results.addresses;
                        this.setState({addresses})

                    })
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    onActiveClick = (id) => {
        const request = {
            id: id,
            active_address: 1
        }
        API.saveAddress(request)
            .then((response) => {
                toast.success(response.user_message);
                API.getAddresses()
                    .then((response) => {
                        const addresses = response.results.addresses;
                        this.setState({addresses})

                    })

            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }

    render() {
        return (
            <React.Fragment>
                <Toast/>
                <section className="container-fluid rtl ">
                    <div className="row">
                        <div className="col-md-3 px-2">
                            <NavBar/>
                        </div>
                        <div className="col-md-9">
                            <TopMenu/>
                            <div className="text-center my-5 text-secondary">
                                <h2>
                                    <strong>مدیریت آدرس ها</strong>
                                </h2>
                            </div>
                            <section className="container rtl  p-3  ">
                                <div className="row">
                                    <div className="col-12 text-left">
                                        <button className="btn btn-info "
                                                onClick={() => this.props.history.push('/profile/address')}>
                                            <FontAwesomeIcon icon={faPlusSquare}/>
                                            &nbsp;
                                            افزودن آدرس جدید
                                        </button>
                                    </div>

                                </div>
                            </section>
                            {
                                this.state.addresses.length === 0 ?
                                    <section className="container pb-1 rtl mt-4  px-4 usual-content  ">
                                        <div className="alert alert-info small text-center">
                                            هنوز هیچ آدرسی ثبت نکرده اید. برای ثبت آدرس جدید دکمه افزودن آدرس جدید را
                                            بزنید
                                        </div>
                                    </section>
                                    :
                                    this.state.addresses.map(address => {
                                        return (


                                            <section key={address.id}
                                                     className={

                                                         address.is_active ? "container pb-1 rtl mt-4  px-4 usual-content pb-3" : 'container pb-1 rtl mt-4  px-4 usual-content is_not_active pb-3'
                                                     }
                                                         title={address.is_active ? '' : 'آدرس غیر فعال است'}>
                                                <div className="row small">
                                                    <div className="col-md-4 custom-border-bottom p-3">
                                                        عنوان آدرس:
                                                        &nbsp;
                                                        <b>
                                                            {address.title}
                                                        </b>
                                                    </div>
                                                    <div
                                                        className="col-md-4 custom-border-bottom custom-border-right p-3">
                                                        نام مسئول هماهنگی:
                                                        &nbsp;
                                                        <b>
                                                            {address.contact_name}
                                                        </b>
                                                    </div>
                                                    <div
                                                        className="col-md-4 custom-border-bottom custom-border-right p-3">
                                                        شماره تماس:
                                                        &nbsp;
                                                        <b>
                                                            {address.contact_number}
                                                        </b>
                                                    </div>
                                                </div>
                                                <div className="row small">

                                                    <div
                                                        className="col-md-4 custom-border-bottom custom-border-right p-3">
                                                        شهر:
                                                        &nbsp;
                                                        <b>
                                                            {address.city ? address.city.title : ''}
                                                        </b>
                                                    </div>
                                                    <div
                                                        className="col-md-4 custom-border-bottom custom-border-right p-3">
                                                        کد پستی:
                                                        &nbsp;
                                                        <b>
                                                            {address.postal_code}
                                                        </b>
                                                    </div>
                                                    <div
                                                        className="col-md-4 custom-border-bottom custom-border-right p-3">
                                                        {address.has_traffic_plan ?
                                                            <b className=' super-small-2'>
                                                                در محدوده طرح ترافیک
                                                            </b> : ''
                                                        }

                                                    </div>
                                                    <div className="col-md-12 custom-border-bottom  p-3">

                                                        <b>
                                                            {address.address}
                                                        </b>

                                                        <span className='text-secondary px-5 super-small float-left'>
                                                            {
                                                                address.type === 73 ?

                                                                    "پیش فرض بارگیری"
                                                                : ""
                                                            }
                                                            {
                                                                address.type === 72 ?

                                                                    " پیش فرض تخلیه"
                                                                    : ""
                                                            }
                                                        </span>



                                                    </div>


                                                </div>
                                                <div className="row">

                                                    <div className="col-md-12 text-left px-3 pt-3 pb-0 text-secondary ">
                                                        {
                                                            address.is_personal_address ?
                                                                <span className='bg-info text-white float-right p-2 super-small-2 rounded-more'>
    آدرس شخصی است
</span>
                                                                : ''
                                                        }
                                        <span title='فعال / غیر فعال کردن آدرس' className='pointer mx-2 make_active'
                                              onClick={() => this.onActiveClick(address.id)}
                                        >
 <FontAwesomeIcon icon={faEyeSlash}/>
                                            &nbsp;

                                        </span>
                                                        <span title='حذف آدرس' className='pointer  mx-2'
                                                              onClick={() => this.onDeleteClick(address.id)}
                                                        >
 <FontAwesomeIcon icon={faWindowClose}/>
                                                            &nbsp;

                                        </span>
                                                        {
                                                            address.is_active ?
                                                                <React.Fragment>
                                                                     <span title='ویرایش آدرس' className='pointer mx-2'
                                                                     onClick={() => this.props.history.push(`/profile/address/${address.id}`)}
                                                                     >
 <FontAwesomeIcon icon={faEdit}/>
                                                                         &nbsp;

                                        </span>

                                                                    <span title='تنظیم به عنوان پیش فرض بارگیری'
                                                                          className='pointer  mx-2'
                                                                        style={address.type === 73 ? {color: 'purple'}  : {}}
                                                                          onClick={() => this.onDefaultClick(address.id , 73)}
                                                                    >
 <FontAwesomeIcon icon={faLevelUpAlt}/>
                                                                        &nbsp;

                                        </span>
                                                                    <span title='تنظیم به عنوان پیش فرض تخلیه'
                                                                          className='pointer mx-2'
                                                                          style={address.type === 72 ? {color: 'purple'} : {}}
                                                                          onClick={() => this.onDefaultClick(address.id , 72)}
                                                                    >
 <FontAwesomeIcon icon={faLevelDownAlt}/>
                                                                        &nbsp;

                                        </span>
                                                                </React.Fragment>
                                                                :
                                                                ''
                                                        }

                                                    </div>
                                                </div>

                                            </section>
                                        )
                                    })
                            }
                        </div>

                    </div>

                </section>

            </React.Fragment>


        );
    }

    componentDidMount = () => {
        API.getAddresses()
            .then((response) => {
                const addresses = response.results.addresses;
                this.setState({addresses})

            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
}

export default Addresses;